const menuBtn = document.getElementById('menuBtn');
const menubar = document.querySelector('.menubar');

menuBtn &&
  menuBtn.addEventListener('click', () => {
    const isOpen = !menubar.classList.contains('hidden');
    const menuImg = menuBtn.querySelector('img');

    if (isOpen) {
      menuImg.src = '/assets/new/icons/menu.svg';
    } else {
      menuImg.src = '/assets/new/icons/close.svg';
    }

    menubar.classList.toggle('hidden');
  });
